export default (el, bind) => {
  const validate = () => {
    const validatorFunction = bind.value;

    if (validatorFunction) {
      const validationResult = validatorFunction(el.value);

      if (validationResult.isValid) {
        el.classList.add('valid');
        el.classList.remove('invalid');
        el.removeAttribute('data-invalidreason');
      } else {
        el.classList.remove('valid');
        el.classList.add('invalid');
        el.setAttribute('data-invalidreason', validationResult.invalidReason);
      }
    }
  };

  validate();
  el.addEventListener('input', validate);
};
